import React, { useState, useEffect } from "react";
import BasePrimeForm from "./BasePrimeForm";
import AmountInput from "../../../components/Utils/AmountInput";

const PrimeNonImposable = ({ id, prime, setPrime, closeEdit }) => {
    const [affichage, setAffichage] = useState('bas');

    useEffect(() => {
        if (prime.category) {
            // Déterminer l'affichage basé sur la catégorie
            if (prime.category === "CBNPNI") {
                setAffichage('brut');
            } else if (prime.category === "NOIMP") {
                setAffichage('bas');
            }
        }
    }, [prime.category]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPrime(p => ({ ...p, [name]: value }));
    };

    const handleMontantChange = (newValue) => {
        setPrime(p => ({ ...p, valeur: newValue }));
    };

    const handleAffichageChange = ({ target: { value } }) => {
        setAffichage(value);
        updatePrimeCategory(value);
    };

    const updatePrimeCategory = (affichageType) => {
        const category = affichageType === 'brut' ? 'CBNPNI' : 'NOIMP';
        setPrime(p => ({ ...p, category }));
    };

    const onBeforeSave = (primeToSave) => {
        // La catégorie est déjà définie par updatePrimeCategory
        if (!primeToSave.category) {
            primeToSave.category = affichage === 'brut' ? 'CBNPNI' : 'NOIMP';
        }
    };

    return (
        <BasePrimeForm
            id={id}
            prime={prime}
            setPrime={setPrime}
            closeEdit={closeEdit}
            title="Prime Non Imposable"
            onBeforeSave={onBeforeSave}
        >
            <div className="form-control">
                <label className="label"><span className="label-text">Nom</span></label>
                <input type="text" className="input input-bordered w-1/2" placeholder="Nom" name="name" value={prime.name || ''} onChange={handleChange} required />
            </div>
            <div className="form-control">
                <label className="label"><span className="label-text">Position</span></label>
                <input type="text" className="input input-bordered w-1/2" placeholder="Position" name="position" value={prime.position || ''} onChange={handleChange} />
            </div>
            <div className="form-control">
                <label className="label"><span className="label-text">Montant</span></label>
                <AmountInput
                    value={prime.valeur}
                    onChange={handleMontantChange}
                    className="input input-bordered w-1/2"
                    required
                />
            </div>
            <div className="form-control">
                <label className="label"><span className="label-text">Affichage</span></label>
                <select className="select select-bordered w-1/2" value={affichage} onChange={handleAffichageChange} disabled={!!id}>
                    <option value='bas'>En bas (avant le net)</option>
                    <option value='brut'>Au niveau du brut</option>
                </select>
                <p className="mt-2 text-sm text-gray-500">
                    <span className="text-red-500">*</span>
                    {affichage === 'brut' 
                        ? " Cette prime sera affichée dans la section brut du bulletin." 
                        : " Cette prime sera affichée en bas, juste avant le montant net."
                    }
                </p>
            </div>
        </BasePrimeForm>
    );
}

export default PrimeNonImposable;